"use strict";
/*
 * Created on 25. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ResultSeverity_1 = require("../../../core/model/errors/ResultSeverity");

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");

var FlagSet_1 = require("../../../core/model/FlagSet");

var ReleasePartValidationKey_1 = require("../../../release/model/alerts/ReleasePartValidationKey");

var RequiresRecalculation_1 = require("../../../release/model/alerts/RequiresRecalculation");
/**
 * Rounding rules changed event.
 * @author Radek Beran
 */


var RoundingRulesChanged =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(RoundingRulesChanged, _EntityEventFlag_1$En);

  function RoundingRulesChanged() {
    _classCallCheck(this, RoundingRulesChanged);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoundingRulesChanged).apply(this, arguments));
  }

  _createClass(RoundingRulesChanged, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return RoundingRulesChanged;
}(EntityEventFlag_1.EntityEventFlag);

exports.RoundingRulesChanged = RoundingRulesChanged;
RoundingRulesChanged.TAG = EntityEventFlag_1.EntityEventFlag.register(RoundingRulesChanged);
RoundingRulesChanged.INSTANCE = new RoundingRulesChanged();
RoundingRulesChanged.MESSAGE = new ValidationResultObject_1.ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, ReleasePartValidationKey_1.ReleasePartMessageCode.RoundingRulesChanged, immutable_1.List.of(), null, null, FlagSet_1.FlagSet.of(ValidationResultFlag_1.ValidationResultFlag, RequiresRecalculation_1.RequiresRecalculation.INSTANCE));